// Google Analytics 4 & Hotjar Integration

// Initialize GA4
export const initGA4 = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId || measurementId === 'G-XXXXXXXXXX') {
    console.warn('GA4 not configured. Add REACT_APP_GA_MEASUREMENT_ID to .env');
    return;
  }

  // Load Google Analytics script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId, {
    anonymize_ip: true,
    allow_google_signals: false,
  });

  console.log('✓ GA4 initialized');
};

// Initialize Hotjar
export const initHotjar = () => {
  const siteId = process.env.REACT_APP_HOTJAR_SITE_ID;
  const version = process.env.REACT_APP_HOTJAR_VERSION || '6';

  if (!siteId || siteId === 'XXXXXXXX') {
    console.warn('Hotjar not configured. Add REACT_APP_HOTJAR_SITE_ID to .env');
    return;
  }

  // Initialize Hotjar
  (function(h, o, t, j, a, r) {
    h.hj = h.hj || function() {
      (h.hj.q = h.hj.q || []).push(arguments);
    };
    h._hjSettings = { hjid: siteId, hjsv: version };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

  console.log('✓ Hotjar initialized');
};

// Track events in both GA4 and Hotjar
export const trackEvent = (eventName, eventParams) => {
  // GA4
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }

  // Hotjar
  if (window.hj) {
    window.hj('event', eventName);
  }
};

// Track phone clicks
export const trackPhoneClick = (source) => {
  trackEvent('phone_click', {
    click_source: source,
    phone_number: '076-005 25 99',
    value: 100,
    currency: 'SEK',
  });
};

// Track CTA clicks
export const trackCTAClick = (ctaName, sectionName) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    section: sectionName,
    value: 1,
  });
};

// Track scroll depth
export const setupScrollTracking = () => {
  const trackedDepths = new Set();

  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = window.scrollY;

    const scrollPercent = Math.round(
      ((scrollTop + windowHeight) / scrollHeight) * 100
    );

    [25, 50, 75, 100].forEach((depth) => {
      if (scrollPercent >= depth && !trackedDepths.has(depth)) {
        trackedDepths.add(depth);
        trackEvent('scroll_depth', {
          scroll_depth_percent: depth,
        });
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => window.removeEventListener('scroll', handleScroll);
};

// Update consent
export const updateConsentMode = (hasConsent) => {
  if (window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: hasConsent ? 'granted' : 'denied',
    });
  }
};